import axios from './customAxios';
import ax from './customAxios';

const eleccionesProvider = {
  guardarEleccion: async (eleccion) => {
    return await axios.post('/elecciones/GuardarEleccion', eleccion);
  },
  guardarVoto: async (eleccion) => {
    return await axios.post('/elecciones/GuardarVoto', eleccion);
  },
  guardarVotos: async (eleccion) => {
    return await axios.post('/elecciones/GuardarVotos', eleccion);
  },
  guardarElectores: async (electores) => {
    return await axios.post('/elecciones/GuardarElectores', electores);
  },
  guardarPostulantes: async (postulantes) => {
    return await axios.post('/elecciones/GuardarPostulantes', postulantes);
  },
  ConfigurarOrden: async (postulantes) => {
    return await axios.post('/elecciones/ConfigurarOrden', postulantes);
  },
  obtenerEleccionVigente: async () => {
    return await axios.get('/elecciones/ObtenerEleccionVIgente');
  },
  obtenerElecciones: async () => {
    return await axios.get('/elecciones/ObtenerElecciones');
  },
  obtenerEleccion: async (eleccion) => {
    return await axios.get(`/elecciones/ObtenerEleccion/${eleccion}`);
  },
  obtenerResultadosVigentes: async () => {
    return await axios.get('/elecciones/ObtenerResultadosEleccionVIgente');
  },
  guardarImagenPostulante: async (e, adjuntos) => {
    const formData = new FormData();
    formData.append('entidadId', e.id);
    formData.append('codigo', e.codigo);
    formData.append('fileName', 'GESSOMA');
    adjuntos.forEach(file => {
      formData.append('formFile', file);
    });
    return await ax.post('/elecciones/GuardarImagenPostulante', formData);
  }
};

export default eleccionesProvider;